$(document).ready(function() {
  const ccSel = $('.cc-cn-section--mob');
    function ccInitSlider() {
      const ccSlider = new Siema({
        selector: '.cc-cn-section--mob .cc-cn-content--mob',
        perPage: {
          300: 3.5,
          375: 4.5,
          450: 5,
          500: 6,
          700: 7,
        },
        duration: 400,
        easing: 'ease-out',
      });
    }
   if ($(window).width() < 767) {
        ccInitSlider();
   }
});